<template>
  <div class="subheader_container">
    <div
      id="highlight-title"
      class="subheader__content"
      :class="
        centralized
          ? 'width-responsiveness--centralized'
          : 'width-responsiveness'
      "
    >
      <div
        v-if="centralized && backButtonVisible"
        class="subheader__back-button"
        @click="handleBackButton()"
      >
        <img
          src="/static/images/icon-return-arrow.svg"
          alt="busca"
        >
        Voltar
      </div>
      <div
        id="tutorial-highlight-subheader"
        class="subheader__title"
      >
        <h2 v-if="title">
          {{ title }}
        </h2>
        <slot name="info" />
        <slot name="actions" />
        <slot name="filter-labels" />
        <slot name="search" />
      </div>
      <div class="subheader__content__right-side">
        <slot />
        <slot name="right-side" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    centralized: {
      type: Boolean,
      default: false
    },
    backButtonVisible: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: null
    }
  },
  methods: {
    handleBackButton () {
      if (this.path) return this.$router.push(this.path)
      return this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/variables";
.subheader_container {
  height: $subHeaderHeight;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  flex-grow: 0;
  position: absolute;
  background-color: #ebebeb;
  top: $mainHeaderHeight;
  z-index: 10;
  left: 0;

  .subheader {
    &__title {
      display: flex;
      justify-content: space-between;
    }

    &__back-button {
      display: flex;
      align-items: center;
      position: absolute;
      left: 9em;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      color: #7f1a54;
      cursor: pointer;
      line-height: 24px;

      img {
        margin-right: 5px;
      }

      &:hover {
        color: #944b75;
        svg > path {
          fill: #944b75;
        }
      }

      svg {
        width: 16px;
        height: 16px;
        min-height: 16px;
        min-width: 16px;
      }
    }

    &__content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      h2 {
        font-size: 22px;
        font-weight: normal;
        letter-spacing: -0.3px;
        text-align: left;
        color: $label-color;
        line-height: 30px;
      }

      .filter-labels {
        color: #7f1a54;
        border-bottom: 3px solid #ddd;
        padding-bottom: 4px;
        text-transform: lowercase;
        cursor: pointer;
      }

      &__right-side {
        margin-left: -100px;
      }
    }
  }

  .subheader-actions-container {
    display: flex;

    &__turn-back {
      display: flex;
      padding-right: 25px;
      padding-left: 25px;

      .md-icon {
        padding: 2px;
        cursor: pointer;
      }
    }
  }

  .subheader-alternative-actions-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    top: 25px;
    position: relative;
    text-align: end;
    justify-content: flex-end;

    button:not(.printer-calibration-button) {
      margin-right: 15px;
      margin-top: auto;
      margin-bottom: auto;

      .md-icon {
        padding: 4px;
      }
    }

    .position-right {
      display: flex;
      padding-right: 25px;

      .md-icon {
        margin: auto 0 auto auto;
        height: 1px;
      }
    }
  }

  .subheader-actions-search {
    position: relative;
    top: 40px;
    min-height: 44px;
    float: right;
  }
}
</style>
